import {
    Badge,
    Box,
    Button,
    Heading,
    HStack,
    Link,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Tr,
    VStack,
} from "@chakra-ui/react";

const applications = [
    { name: "glasnost", owner: true },
    { name: "facebook" },
    { name: "twitter" },
    { name: "tesla", owner: true },
];

const Applications = () => {
    return (
        <>
            <VStack gap={5}>
                <Box w={"100%"}>
                    <HStack justifyContent={"space-between"}>
                        <Heading size={"md"}>Applications</Heading>
                        <Button variant={"outline"}>New application</Button>
                    </HStack>
                </Box>
                <Box w={"100%"}>
                    <TableContainer
                        borderColor={"gray.200"}
                        borderStyle={"solid"}
                        borderWidth={"1px"}
                        borderRadius={"md"}
                    >
                        <Table variant={"simple"}>
                            <Tbody>
                                {applications.map(({ name, owner }, i) => {
                                    return (
                                        <Tr>
                                            <Td>
                                                <Stack
                                                    direction={"row"}
                                                    align={"baseline"}
                                                >
                                                    <Box>
                                                        <Link variant={'intense-blue'} href="#">{name}</Link>
                                                    </Box>
                                                    <Badge
                                                        variant={"outline"}
                                                        colorScheme={
                                                            owner
                                                                ? "purple"
                                                                : "gray"
                                                        }
                                                        borderRadius={"md"}
                                                    >
                                                        {owner
                                                            ? "owner"
                                                            : "member"}
                                                    </Badge>
                                                </Stack>
                                            </Td>
                                            <Td>
                                                <HStack
                                                    justifyContent={"flex-end"}
                                                >
                                                    {owner && (
                                                        <Button
                                                            variant={"outline"}
                                                            color={"gray.300"}
                                                            borderColor={
                                                                "gray.300"
                                                            }
                                                            textColor={
                                                                "gray.600"
                                                            }
                                                            _hover={{
                                                                bg: "gray.200",
                                                            }}
                                                        >
                                                            Settings
                                                        </Button>
                                                    )}
                                                    <Button
                                                        variant={
                                                            "danger-outline"
                                                        }
                                                    >
                                                        Leave
                                                    </Button>
                                                </HStack>
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            </VStack>
        </>
    );
};

export default Applications;
